/*
 * @Author: Dong
 * @Date: 2022-04-20 11:14:22
 * @LastEditors: zhang lin
 * @LastEditTime: 2023-02-02 14:49:58
 */
import {
  SELECT_NODE_VERSION,
  CLEAR_FILE_CONFIG,
  CHAGNE_NODE_FORM,
  SET_HOSTS,
  SET_INSTALLA_TYPE,
  SET_NODE_DATA,
} from '../constant';

export const selectNodeVersion = (payload: any) => ({
  type: SELECT_NODE_VERSION,
  payload,
});

export const clearData = () => ({
  type: CLEAR_FILE_CONFIG,
});

export const changeNodeForm = (payload: any) => ({
  type: CHAGNE_NODE_FORM,
  payload,
});

export const setHosts = (payload: any) => ({
  type: SET_HOSTS,
  payload,
});
export const setInstallType = (payload: any) => ({
  type: SET_INSTALLA_TYPE,
  payload,
});

export const setNodeData = (payload: any) => ({
  type: SET_NODE_DATA,
  payload,
});
